import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { Criptografia } from "../Utils/Criptografia"

type Props = {
    children: JSX.Element,
    replace?: boolean    
}

export const PrivateRoute = ({children}: Props) => {

  const location = useLocation();  

  // if (location.pathname.indexOf('app.gestorweb.tiautomacao.com') < 0){
  //   return <Navigate to="/"/>
  // }
 
  let isLogged = false;

  if (localStorage.getItem('@ecommerce/hash') === null){
    return <Navigate to="/login" replace/>
  }
        
  if (localStorage.getItem('@ecommerce/hash')){  
    isLogged = true;
  }

  return isLogged ? children : <Navigate to="/login"/>

}